import Logo from "./Logo";
import React from "react";
import { ArrowUpRight, ShieldCheck, Mail, Phone, MapPin } from "lucide-react";

export default function Footer({ onTabChange }) {
  const handleItemClick = (tabId) => {
    onTabChange(tabId);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer
      id="jpsy-footer"
      className="bg-[#111215] border-t border-zinc-800 text-slate-400 py-12 text-sm font-sans"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Logo Brand Info */}
          <div className="lg:col-span-2 space-y-4">
            <button type="button" aria-label="JPSY home" onClick={() => handleItemClick("home")} className="block w-48 max-w-full">
              <Logo className="block h-auto w-full" />
            </button>

            <p className="text-xs text-slate-400 leading-relaxed max-w-sm">
              JPSY Supply Chain is an advanced technology supply chain partner in
              India. Over 5 Billion+ shipments delivered across a high-speed
              linehaul air and surface express corridor network.
            </p>

            <div className="space-y-2.5 text-xs">
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-[#263f98] shrink-0" />
                <span>Customer Support: 1800-JPSY-SUPPORT (Toll Free)</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-[#263f98] shrink-0" />
                <span>Email: support@jpsy-logistics.com</span>
              </div>
              <div className="flex items-center gap-2">
                <MapPin className="w-4 h-4 text-[#263f98] shrink-0" />
                <span>
                  HQ Office: Vatika Business Tower, Sector 49, Gurugram, India
                </span>
              </div>
            </div>
          </div>

          {/* Column Services */}
          <div>
            <h4 className="font-semibold text-white text-xs uppercase tracking-widest mb-4 border-l-2 border-[#263f98] pl-2">
              Services
            </h4>
            <ul className="space-y-2 text-xs">
              <li><button onClick={() => handleItemClick("service_local_delivery")} className="hover:text-[#263f98] transition-colors text-left cursor-pointer">Local Delivery</button></li>

              <li>
                <button
                  onClick={() => handleItemClick("service_express_parcel")}
                  className="hover:text-[#263f98] transition-colors text-left cursor-pointer"
                >
                  Express Parcel
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleItemClick("service_warehousing")}
                  className="hover:text-[#263f98] transition-colors text-left cursor-pointer"
                >
                  Warehousing
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleItemClick("service_part_truckload")}
                  className="hover:text-[#263f98] transition-colors text-left cursor-pointer"
                >
                  Part Truckload
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleItemClick("service_full_truckload")}
                  className="hover:text-[#263f98] transition-colors text-left cursor-pointer"
                >
                  Full Truckload
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleItemClick("service_international")}
                  className="hover:text-[#263f98] transition-colors text-left cursor-pointer"
                >
                  International
                </button>
              </li>
              <li><button onClick={() => handleItemClick("service_transport_one")} className="hover:text-[#263f98] transition-colors text-left cursor-pointer">TransportOne</button></li>
              <li><button onClick={() => handleItemClick("service_data_intelligence")} className="hover:text-[#263f98] transition-colors text-left cursor-pointer">Data Intelligence</button></li>
              <li>
                <button
                  onClick={() => handleItemClick("service_jpsy_maps")}
                  className="hover:text-[#263f98] transition-colors text-left cursor-pointer"
                >
                  JPSY Maps (Beta)
                </button>
              </li>
            </ul>
          </div>

          {/* Column Solutions */}
          <div>
            <h4 className="font-semibold text-white text-xs uppercase tracking-widest mb-4 border-l-2 border-[#263f98] pl-2">
              Solutions
            </h4>
            <ul className="space-y-2 text-xs">

              <li>
                <button
                  onClick={() => handleItemClick("solution_d2c_brands")}
                  className="hover:text-[#263f98] transition-colors text-left cursor-pointer"
                >
                  D2C Brands
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleItemClick("solution_personal_courier")}
                  className="hover:text-[#263f98] transition-colors text-left cursor-pointer"
                >
                  Personal Courier
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleItemClick("solution_b2b_enterprises")}
                  className="hover:text-[#263f98] transition-colors text-left cursor-pointer"
                >
                  B2B Enterprises
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleItemClick("solution_rto_predictor")}
                  className="hover:text-[#263f98] transition-colors text-left cursor-pointer"
                >
                  RTO Predictor
                </button>
              </li>
            </ul>
          </div>

          {/* Column Corporate */}
          <div>
            <h4 className="font-semibold text-white text-xs uppercase tracking-widest mb-4 border-l-2 border-[#263f98] pl-2">
              Company
            </h4>
            <ul className="space-y-2 text-xs">

              <li>
                <button
                  onClick={() => handleItemClick("company_about_us")}
                  className="hover:text-[#263f98] transition-colors text-left cursor-pointer flex items-center gap-1"
                >
                  <span>About Us</span>
                  <ArrowUpRight className="w-3 h-3" />
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleItemClick("company_governance")}
                  className="hover:text-[#263f98] transition-colors text-left cursor-pointer flex items-center gap-1"
                >
                  <span>Governance</span>
                  <ArrowUpRight className="w-3 h-3" />
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleItemClick("company_press_release")}
                  className="hover:text-[#263f98] transition-colors text-left cursor-pointer flex items-center gap-1"
                >
                  <span>Press Releases</span>
                  <ArrowUpRight className="w-3 h-3" />
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleItemClick("company_careers")}
                  className="hover:text-[#263f98] transition-colors text-left cursor-pointer flex items-center gap-1"
                >
                  <span>Careers</span>
                  <ArrowUpRight className="w-3 h-3" />
                </button>
              </li>
              <li><button onClick={() => handleItemClick("company_blog")} className="hover:text-[#263f98] transition-colors text-left cursor-pointer">Blog</button></li>
              <li>
                <button
                  onClick={() => handleItemClick("partner_franchise")}
                  className="hover:text-[#263f98] transition-colors text-left cursor-pointer flex items-center gap-1"
                >
                  <span>Partner Programs</span>
                  <ArrowUpRight className="w-3 h-3" />
                </button>
              </li>
              <li><button onClick={() => handleItemClick("partner_delivery_partner")} className="hover:text-[#263f98] transition-colors text-left cursor-pointer">Delivery Partner</button></li>
              <li><button onClick={() => handleItemClick("partner_fleet_owners")} className="hover:text-[#263f98] transition-colors text-left cursor-pointer">Fleet Owners</button></li>
              <li><button onClick={() => handleItemClick("partner_logistics_school")} className="hover:text-[#263f98] transition-colors text-left cursor-pointer">Delivery School of Supply Chain</button></li>
            </ul>
          </div>
        </div>

        {/* Lower Legal Bar */}
        <div className="border-t border-zinc-800 mt-12 pt-6 flex flex-col md:flex-row justify-between items-center gap-4 text-xs">
          <p>
            © {new Date().getFullYear()} JPSY Supply Chain Limited. All rights
            reserved.
          </p>
          <div className="flex gap-4">
            <span className="hover:text-white cursor-pointer">
              Privacy Policy
            </span>
            <span className="hover:text-white cursor-pointer">
              Terms & Conditions
            </span>
            <span className="hover:text-white cursor-pointer">
              Cookie Policy
            </span>
            <span className="hover:text-white cursor-pointer">Disclaimers</span>
          </div>
          <div className="flex items-center gap-1 text-slate-500">
            <ShieldCheck className="w-4 h-4 text-emerald-500" />
            <span>ISO 27001 Certified System</span>
          </div>
        </div>
      </div>
    </footer>
  );
}








